module.exports = __webpack_public_path__ + "img/ENG.41db6d61.svg";